import { AbstractApi } from '@/api/AbstractApi'
import { AddPageContent } from '@/model/page/AddPageContent'
import request from '@/api/request'

class PageApi extends AbstractApi {
  async addContent(content: AddPageContent, pageSlug: string) {
    const route = this.generateAdminRoute({ pageSlug, suffix: 'contents' })

    return request.put(route, content, true)
  }

  async showContents(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'contents' })

    return request.get(route)
  }

  async updateContentPosition(contentSlug: string, pageSlug: string, position: number) {
    const route = this.generateAdminRoute({ slug: pageSlug, suffix: 'content-position' })

    return request.put(route, { contentSlug, position })
  }

  async show(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'show' })

    return request.put(route, { isShown: true })
  }

  async hide(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'hide' })

    return request.put(route, { isShown: false })
  }
}

export default new PageApi('page')
